import React, {ReactNode} from 'react';
import clsx from "clsx";

const AuthLayout = ({ children, isSignUp = false }: { children: ReactNode; isSignUp?: boolean}) => {
  return (
    <div className="flex h-screen items-center">
      <div className="w-[600px] flex flex-col justify-center items-center lg:bg-signUpBG lg:w-full lg:h-screen lg:px-4">
        <div className="w-full max-w-[358px]">
          {children}
        </div>
      </div>
      <div className={clsx(
        "w-full h-full relative lg:hidden",
          isSignUp ? "bg-signUpBG" : "bg-signIn"
        )}
      />
    </div>
  )
};

export default AuthLayout;
